import { useQuery } from "@tanstack/react-query";
import { Order } from "../domain/order";
import { HttpOrdersRepository } from "../application/Orders";
import { useUser } from "@/backend/user";
import { useOrderContext } from "./context/OrderContext";

const repository = new HttpOrdersRepository();

// ...existing code...
export function useOrders() {
  return useOrderContext();
}
//

export function useOrdersByShopper() {
  const { shopper } = useUser();
  const shopperId = shopper?.shopperId;
  const { data, isLoading, error } = useQuery<Order[]>({
    queryKey: ["orders", "shopper", shopperId],
    //@ts-ignore
    queryFn: () => repository.getAllByShopper(shopperId),
    enabled: !!shopperId,
  });

  return { orders: data || [], isLoading, error };
}

export function useOrdersByAdmin() {
  const { data, isLoading, error } = useQuery<Order[]>({
    queryKey: ["orders", "admin"],
    queryFn: () => repository.getAllByAdmin(),
  });

  return { orders: data || [], isLoading, error };
}

export function useCompleteOrders() {
  const { data, isLoading, error } = useQuery<Order[]>({
    queryKey: ["orders", "complete"],
    queryFn: () => repository.getAllComplete(),
  });

  return { orders: data || [], isLoading, error };
}

export function useCompleteOrdersByShopper(shopperId: string) {
  const { data, isLoading, error } = useQuery<Order[]>({
    queryKey: ["orders", "complete", "shopper", shopperId],
    queryFn: () => repository.getAllCompleteByShopper(shopperId),
    enabled: !!shopperId,
  });

  return { orders: data || [], isLoading, error };
}

export function useCompleteOrdersByAdmin() {
  const { data, isLoading, error } = useQuery<Order[]>({
    queryKey: ["orders", "complete", "admin"],
    queryFn: () => repository.getAllCompleteByAdmin(),
  });

  return { orders: data || [], isLoading, error };
}
